import React, {useCallback, useContext, useState} from 'react';
import logo from "../../../assets/v2/Logo-Orca.svg";
import {Avatar, Badge, Typography} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import {MESSAGE_TEXT, PROFILE_TEXT, OCEAN__MAIN_GLOBAL_THEMA_TEXT, OCEAN__GLOBAL_THEMA_TEXT_DARK} from "../../../strings/IT";
import IconButton from "@mui/material/IconButton";
import {setThemeType} from "../../../services/AppServices";
import Brightness4TwoToneIcon from "@mui/icons-material/Brightness4TwoTone";
import Brightness5TwoToneIcon from "@mui/icons-material/Brightness5TwoTone";
import NotificationsNoneTwoToneIcon from "@mui/icons-material/NotificationsNoneTwoTone";
import {getUserNameAndSurname} from "../../../utils/GenericUtils";
import Profile from "./Profile";
import {callcenterStyle} from "../../../styles/pages/callcenter/CallcenterStyle";
import {AppContext} from "../../../App";
import {ChangePasswordDialog} from "../../auth/utils/ChangePasswordDialog";
import ArrowBackTwoToneIcon from "@mui/icons-material/ArrowBackTwoTone";
import {useHistory} from "react-router-dom";
import clsx from "clsx";
import multiavatar from "@multiavatar/multiavatar";
import SVG from "react-inlinesvg";

export const SimpleHeader = ({back = false, title = "Ocean", backPosition}) => {
	const classes = callcenterStyle();
	const appContext = useContext(AppContext);
	const [anchorEl, setAnchorEl] = useState(null);
	const [openChangePassword, setOpenChangePassword] = useState(false);
	const history = useHistory();
	
	const handleGoBack = useCallback(() => {
		if (backPosition) {
			history.push(backPosition);
		} else {
			history.goBack();
		}
	}, [history, backPosition])
	
	return (
        <React.Fragment>
            <header className={clsx(classes.header)}>
				{
					back &&
					<Tooltip title={"Torna indietro"}>
						<IconButton className={classes.menuButton} onClick={handleGoBack} size="large">
							<ArrowBackTwoToneIcon/>
						</IconButton>
					</Tooltip>
				}
				<img className={classes.logo} src={logo} alt={"logo"} onClick={() => history.push("/")}/>
				<div className={classes.fakeDiv}/>
				<Typography variant={"h4"} component={"h1"} className={classes.title}>
					<b>{title}</b>
				</Typography>
				<Tooltip title={appContext.state.theme.palette.mode === "light" ? OCEAN__MAIN_GLOBAL_THEMA_TEXT : OCEAN__GLOBAL_THEMA_TEXT_DARK}>
					<IconButton
                        color="inherit"
                        onClick={() => setThemeType(appContext.state.theme.palette.mode === "light" ? "dark" : "light",
							appContext.state.theme, appContext.dispatch)}
                        size="large">
						{
							appContext.state.theme.palette.mode === "light" ?
								<Brightness4TwoToneIcon className={classes.icon}/> :
								<Brightness5TwoToneIcon className={classes.icon}/>
						}
					</IconButton>
				</Tooltip>
				<Tooltip title={MESSAGE_TEXT}>
					<IconButton color="inherit" size="large">
						{appContext.state.theme.palette.mode === "light" ?
							<Badge badgeContent={0} color="secondary">
								<NotificationsNoneTwoToneIcon className={classes.icon}/>
							</Badge> :
							<Badge badgeContent={0} color="secondary">
								<NotificationsNoneTwoToneIcon className={classes.icon}/>
							</Badge>}
					</IconButton>
				</Tooltip>
				<Tooltip title={PROFILE_TEXT}>
					<IconButton
                        onClick={(e) => setAnchorEl(e.currentTarget)}
                        color="inherit"
                        size="large">
						<Avatar
							className={classes.profile}>
							<SVG src={multiavatar(getUserNameAndSurname())}/>
						</Avatar>
					</IconButton>
				</Tooltip>
				<Profile
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					handleClose={setAnchorEl}
					handleOpenChangePassword={() => setOpenChangePassword(true)}
				/>
			</header>
            <ChangePasswordDialog
				open={openChangePassword}
				handleClose={() => setOpenChangePassword(false)}
			/>
        </React.Fragment>
    );
};
